module.exports = __webpack_public_path__ + "img/remind-icon5.2ab6d5dc.png";